export const CLOSE_STATISTICS = "CLOSE_STATISTICS";
export const SET_DESKTOP_DRAWER_STATUS = "SET_DESKTOP_DRAWER_STATUS";
export const SET_MOBILE_DRAWER_STATUS = "SET_MOBILE_DRAWER_STATUS";
export const TOGGLE_COMPANY_LEVEL_DIALOG_OPEN =
    "TOGGLE_COMPANY_LEVEL_DIALOG_OPEN";
export const TOGGLE_STATISTICS = "TOGGLE_STATISTICS";
